/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_Valve_HeadlineInputs */



/**
* | output |
* | --- |
* | "Control heating room by room" |
*
* @param {Go_Further_Valve_HeadlineInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_valve_headline = /** @type {((inputs?: Go_Further_Valve_HeadlineInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Valve_HeadlineInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Control heating room by room")
	return /** @type {LocalizedString} */ ("Régulez le chauffage pièce par pièce")
});